<template>
  <div class="main introduceMain">
    <div class="top">
      <span class="title">协会介绍</span>
    </div>

    <div class="content">
      <div class="heading">
        <i class="el-icon-document"></i>
        <span class="caption">协会介绍</span>
      </div>
      <p
        class="text"
      >2013年6月，经上海市社团管理局和上海市住房和城乡建设管理委员会（原上海市城乡建设和交通委员会）批准，上海市绿色建筑协会在原上海市绿色建筑促进会和上海市绿色建筑与节能专业委员会的基础上成立了上海市绿色建筑协会，确定了“以服务会员单位需求为宗旨、以政府工作要求为导向”的工作思路。主要由从事绿色建筑的科研、规划、设计、开发、施工、教育、信息管理、服务及相关设备、材料生产企业自愿参加的非营利性社会团体协会。</p>
      <p class="text">
        协会官网：
        <a href="http://www.shgbc.org" target="_blank" class="website">www.shgbc.org</a>
      </p>
      <p class="text" style="margin-top: 10px;">
        协会微信：
        <img src="../assets/code.jpg" style="width: 125px;margin-bottom: -10px" />
      </p>
      <div class="logoDiv">
        <img src="../assets/logo.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss">
.introduceMain {
  .text {
    font-size: 22px;
    text-indent: 2em;
    color: #535050;
    font-weight: 400;
    margin-left: 2em;
    line-height: 30px;
    .website {
      color: #00b0f0;
    }
    .website:hover {
      color: #909399;
    }
  }
  .logoDiv {
    margin-left: 25%;
    margin-top: 35px;
    img {
      width: 60%;
    }
  }
}
</style>
